import cx from 'classnames';
import dateFormat from 'dateformat';
import _ from "lodash";

import UserIcon from "src/pages/dealRoom/components/chat/userIcon";
import { Message, UserDetails } from "../index";

import styles from "./styles.module.scss";

interface MessageComponentProps {
  message: Message;
  user: UserDetails;
  isSender: boolean;
  showOnlineStatus: boolean;
}

const MessageComponent: React.FC<MessageComponentProps> = ({ message, user, isSender, showOnlineStatus }) => {
  const getMessageSentTime = () => {
    let timestamp = +Date();
    const receivedTime = _.get(message, 'receivedTime', null);
    
    if (receivedTime) {
      timestamp = receivedTime;
    }

    const result = dateFormat(timestamp / 10000, 'mmm d, yy hh:MM TT');

    return result;
  }

  return (
    <div className={cx(styles.messageSectionContainer, {
      [styles.receiver]: !isSender,
      [styles.sender]: isSender,
    })}>
      <div className={cx(styles.messageInfoContainer, {
        [styles.receiver]: !isSender,
        [styles.sender]: isSender,
      })}>
        <UserIcon showOnlineStatus={showOnlineStatus} isOnline={isSender} imageSrc={_.get(user, 'profilePicture', '')} />
        <p className={styles.username}>{`${_.get(user, 'name', '')}`}</p>
        <p className={styles.messageTime}>{getMessageSentTime()}</p>
      </div>
      {
        _.map(_.get(message, 'contents', []), ((content: string) => {
          return (
            <div className={cx(styles.message, {
              [styles.sent]: !isSender,
              [styles.received]: isSender,
            })} key={message.id}>{content}
            </div>
          );
        }))
      }
    </div>
  )
}

export default MessageComponent;